import axios from 'axios';

const BASE_URL = import.meta.env.VITE_APP_API || 'http://localhost:5000/';

const http = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

/**
 * Thin wrapper around the existing Azure Cognitive Translator endpoint.
 * The endpoint returns the translated text directly, unlike the V2 tax APIs
 * which return a ResponseModel envelope.
 */
export const languageTranslationApi = {
  async translate(text, from, to) {
    const response = await http.post('api/v0/AppInterface/cognitive_translate', {
      RequestText: String(text ?? ''),
      from,
      to,
    });

    const translated = response && response.data;
    if (typeof translated === 'string') return translated;
    if (translated && typeof translated === 'object') {
      const value = translated.data ?? translated.Data ?? translated.text ?? translated.Text;
      if (typeof value === 'string') return value;
    }
    throw new Error('Translation service returned an invalid response.');
  },
};

export default languageTranslationApi;
